<!--
 * @Author: hfxie
 * @Date: 2021-12-09 11:24:53
 * @LastEditors: hfxie
 * @LastEditTime: 2023-05-22 17:09:20
 * @Description: 右侧图区垂直线
-->
<template>
  <div
    class="y-axis"
    v-show="isShow"
    :style="{
      'left': left,
      'height': height,
      'z-index': zIndex,
    }"
  >
    <div
      class="y-axis-show"
      :style="{
        'border-left-color': color,
        'border-left-style': type,
        'border-left-width': width + 'px',
      }"
    ></div>
  </div>

</template>

<script>
export default {
  name: "YAxis",
  data() {
    return {};
  },
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    left: {
      type: String,
      default: () => { return "0"; },
    },
    height: {
      type: String,
      default: () => { return "100%"; },
    },
    zIndex: {
      type: Number,
      default: () => { return 100; },
    },
    color: {
      type: String,
      default: () => { return "transparent"; },
    },
    type: {
      type: String,
      default: () => { return "solid"; },
    },
    width: {
      type: Number,
      default: () => { return 1; },
    },

  },
};
</script>
<style scoped lang='less'>
// 竖轴
.y-axis {
  width: auto;
  min-width: 1px;
  height: 100%;
  position: absolute;
  z-index: 100;
  left: -10px;
  top: 0;
  .y-axis-show{
    width: 0px;
    height: 100%;
    border-right: 0;
    border-top: 0;
    border-bottom: 0;
    border-left-style: solid;
    border-left-color: purple;
    border-left-width: 1px;
  }
}

</style>
